import React from 'react';
import { returnedTypes, measurementType } from './MeasurementEnums';
import TextField, { TextFieldProps } from '../Inputs/TextField';
import MeasurementsAction from './index';
import styles from './index.module.scss';
import UnitWidget from './UnitWidget';
import { InputLabel } from '@mui/material';
import classNames from 'classnames';
import { UseFormGetValues, FieldValues } from 'react-hook-form';

interface MeasurementFieldProps extends TextFieldProps {
  name: string;
  label?: string;
  measureType: measurementType;
  returnedType: returnedTypes;
  getValues: UseFormGetValues<FieldValues>;
  isHideMeasurementsIcon?: boolean;
  inputClassName?: string;
  textFieldClasses?: {
    root?: string;
    disabled?: string;
    wrapperClassName?: string;
    endAdornmentClassName?: string;
    input?: string;
  };
  dataCy?: string;
}

export const MeasurementField = React.forwardRef((props: MeasurementFieldProps, ref) => {
  const {
    name,
    defaultValue,
    label,
    measureType,
    returnedType,
    getValues,
    isHideMeasurementsIcon,
    inputClassName,
    required,
    textFieldClasses,
    dataCy,
    ...textFieldProps
  } = props;

  const preventMinus = (event: React.KeyboardEvent) => {
    if (event.code === 'Minus' || event.charCode === 45) {
      event.preventDefault();
    }
  };

  return (
    <div
      className={classNames(
        styles.measurementsInput,
        'relative mb-2 mr-2',
        inputClassName,
        textFieldClasses?.input,
      )}
    >
      <div
        className={classNames(styles.measurementsWrapper, {
          [styles.unitWidget]: inputClassName,
        })}
      >
        {label && (
          <InputLabel className={styles.label}>
            {label}
            {required ? <span>*</span> : null}
          </InputLabel>
        )}
        {!isHideMeasurementsIcon && <MeasurementsAction />}
      </div>
      <div className="relative">
        <TextField
          fullWidth
          name={name}
          inputRef={ref}
          defaultValue={defaultValue}
          type="number"
          data-cy={dataCy}
          InputProps={{
            inputProps: {
              min: 0,
              step: 'any', // eslint-disable-line
              onKeyPress: preventMinus,
            },
            endAdornment: (
              <UnitWidget
                type={measureType}
                value={getValues()[name]}
                returnedType={returnedType}
                className={textFieldClasses?.endAdornmentClassName}
              />
            ),
          }}
          wrapperClassName={classNames('mb-4', textFieldClasses?.wrapperClassName)}
          inputClassName={textFieldClasses?.root}
          disabledClassName={textFieldClasses?.disabled}
          {...textFieldProps}
          variant="outlined"
        />
      </div>
    </div>
  );
});
export default MeasurementField;
